module.exports = __webpack_public_path__ + "static/media/pdf_files.556928cd.png";